import { AbstractPaginatedResultList, PaginatedResultList } from '@uzurv/core';
import { autoserializeAs, inheritSerialization } from 'cerialize';
import { JourneyDetail } from '../journey-detail';

@inheritSerialization(AbstractPaginatedResultList)
export class PaginatedJourneyDetailList extends AbstractPaginatedResultList implements PaginatedResultList<JourneyDetail> {
  @autoserializeAs(JourneyDetail)
  results: Array<JourneyDetail>;
}
